import React from 'react';
import { useSearchParams } from 'react-router-dom';

const PDFViewer = () => {
  const [searchParams] = useSearchParams();
  
  const pdfUrl = searchParams.get('pdf');
  const page = searchParams.get('page') || 1;


  if (!pdfUrl) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">PDF Viewer</h1>
          <p className="text-gray-600">No PDF URL provided</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col">
      {/* Header */}
      <div className="bg-gray-100 border-b px-4 py-2 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h1 className="text-lg font-medium">SCG Source Document</h1>
          <div className="text-sm text-gray-600">Page {page}</div>
        </div>
        <button
          onClick={() => window.close()}
          className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          Close
        </button>
      </div>
      
      {/* PDF Viewer */}
      <div className="flex-1">
        <iframe
          src={`${pdfUrl}#page=${page}`}
          className="w-full h-full border-0"
          title="SCG Source Document"
        />
      </div>
    </div>
  );
};

export default PDFViewer;